import { IWheelProps } from '~/actions/extraHTML/wheelOfFortune';
import { getDegree } from '~/actions/extraHTML/wheelOfFortune/helpers';
import { sectorHTML } from '~/actions/extraHTML/wheelOfFortune/html/rotationElements/sectorHTML';

export const wheelSectorsClass = 'wheelSectors';

export const wheelSectors = (wheelParams: IWheelProps, radius: number) => {
  const sectors = wheelParams.sectors;
  const winSectorNumber = wheelParams.animationProps.winSectorNumber;

  const degree = getDegree(sectors.length);

  const sectorsHTMLArray = sectors?.map((sector, key) => {
    return sectorHTML({ number: key, size: radius, degree, winSectorNumber,  ...sector });
  });

  return `<div class='${wheelSectorsClass}'>
    ${sectorsHTMLArray.join('')}
  </div>`;
};
